import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormGroup, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { WorkflowDashboardConfiguration } from './workflow-dashboard-configuration';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-workflow-dashboard-form',
  templateUrl: './workflow-dashboard-form.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class WorkflowDashboardFormComponent {
  //TODO: Check why any is here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data = inject<WorkflowDashboardConfiguration>('formData' as any);
  private fb = inject(FormBuilder);

  form: FormGroup;

  @Output() dataChange = new EventEmitter<WorkflowDashboardConfiguration>();

  constructor() {
    const data = this.data;

    this.form = this.fb.group({
      title: [data.title || ''],
      description: [data.description || ''],
    });
    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }
}
